<template>
  <div v-if="company.company_key === 'keystonepmc'" class="register-popup-container">
    <register :component="component" />
    <popup :config="modalConfig" custom-width="710px" @close="onSuccessModalClosed()">
      <template #header><div></div></template>
      <template #content>
        <div class="tw-flex tw-flex-col tw-p-4">
          <div v-if="vars.popupTitleHtml" class="tw-mb-3" v-html="vars.popupTitleHtml"></div>
          <h3
            v-else-if="vars.popupTitleText"
            class="register-entry-title tw-mb-3"
            style="color: var(--c-primary) !important"
            :class="{ 'tw-text-center': vars.textCenterBool }"
          >
            {{ vars.popupTitleText }}
          </h3>

          <h3 v-else class="register-entry-title tw-mb-3" style="color: var(--c-primary) !important">
            How our Heads Up Property
            <br class="tw-hidden lg:tw-visible" />Alerts help you
          </h3>
          <span class="tw-inline">
            <p v-html="registrationEntryPopupText" :class="{ 'tw-text-center': vars.textCenterBool }" />
            <p>Let's get started...</p>
          </span>
          <div
            class="tw-mt-9 tw-flex tw-flex-col tw-gap-x-6 tw-gap-y-2 md:tw-flex-row md:tw-gap-y-0"
            :class="{ 'tw-items-center tw-justify-center': vars.textCenterBool }"
          >
            <nuxt-link v-if="vars.buyBool" to="/heads-up-alerts/register/buy" :external="true" class="n-primary">
              LOOKING TO BUY
            </nuxt-link>

            <nuxt-link
              v-if="vars.rentBool && company.company_key !== 'keystonepmc'"
              to="/heads-up-alerts/register/rent"
              :external="true"
              class="n-primary custom-color"
            >
              LOOKING TO RENT
            </nuxt-link>
          </div>
        </div>
      </template>
    </popup>
  </div>

  <div v-if="company.company_key === 'kineticestateagents'" class="register-popup-container">
    <register :component="component" />
    <popup :config="modalConfig" custom-width="710px" @close="onSuccessModalClosed()">
      <template #header><div></div></template>
      <template #content>
        <div class="tw-flex tw-flex-col tw-p-4">
          <div v-if="vars.popupTitleHtml" class="tw-mb-3" v-html="vars.popupTitleHtml"></div>
          <h3
            v-else-if="vars.popupTitleText"
            class="register-entry-title tw-mb-3"
            style="color: var(--c-primary) !important"
            :class="{ 'tw-text-center': vars.textCenterBool }"
          >
            {{ vars.popupTitleText }}
          </h3>

          <h3 v-else class="register-entry-title tw-mb-3" style="color: var(--c-primary) !important">
            How our Heads Up Property
            <br class="tw-hidden lg:tw-visible" />Alerts help you
          </h3>
          <span class="tw-inline">
            <p v-html="registrationEntryPopupText" :class="{ 'tw-text-center': vars.textCenterBool }" />
            <p>Let's get started...</p>
          </span>
          <div
            class="tw-mt-9 tw-flex tw-flex-col tw-gap-x-6 tw-gap-y-2 md:tw-flex-row md:tw-gap-y-0"
            :class="{ 'tw-items-center tw-justify-center': vars.textCenterBool }"
          >
            <nuxt-link v-if="vars.buyBool" to="/heads-up-alerts/register/buy" :external="true" class="n-primary">
              LOOKING TO BUY
            </nuxt-link>

            <nuxt-link
              v-if="vars.rentBool"
              to="/heads-up-alerts/register/rent"
              :external="true"
              class="n-primary custom-color"
            >
              LOOKING TO RENT
            </nuxt-link>
          </div>
        </div>
      </template>
    </popup>
  </div>

  <div v-else class="register-popup-container">
    <register :component="component" />
    <popup :config="modalConfig" custom-width="710px" @close="onSuccessModalClosed()">
      <template #header><div></div></template>
      <template #content>
        <div class="register-popup-entry tw-flex tw-flex-col tw-p-4">
          <div v-if="vars.popupTitleHtml" class="tw-mb-3" v-html="vars.popupTitleHtml"></div>
          <h3
            v-else-if="vars.popupTitleText"
            class="register-entry-title tw-mb-3"
            style="color: var(--c-primary) !important"
            :class="{ 'tw-text-center': vars.textCenterBool }"
          >
            {{ vars.popupTitleText }}
          </h3>

          <h3 v-else class="register-entry-title tw-mb-3" style="color: var(--c-primary) !important">
            How our Heads Up Property
            <br class="tw-hidden lg:tw-visible" />Alerts help you
          </h3>
          <span class="tw-inline">
            <p v-html="registrationEntryPopupText" :class="{ 'tw-text-center': vars.textCenterBool }" />
            <p>Let's get started...</p>
          </span>
          <div
            class="tw-mt-9 tw-flex tw-flex-col tw-gap-x-6 tw-gap-y-2 md:tw-flex-row md:tw-gap-y-0"
            :class="{ 'tw-items-center tw-justify-center': vars.textCenterBool }"
          >
            <nuxt-link
              v-if="vars.buyBool"
              to="/heads-up-alerts/register/buy"
              :external="true"
              :class="company.company_key === 'copeandco' ? 'n-secondary' : 'n-primary'"
            >
              LOOKING TO BUY
            </nuxt-link>

            <nuxt-link
              v-if="vars.rentBool"
              to="/heads-up-alerts/register/rent"
              :external="true"
              :class="company.company_key === 'copeandco' ? 'n-tertiary custom-color' : 'n-primary'"
            >
              LOOKING TO RENT
            </nuxt-link>
          </div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script lang="ts">
import RegisterEntry from '~/components/common/register/RegisterEntry.vue';
import { ComponentMixin } from '~/mixins/component.mixin';
import Register from '~/components/theme7/register/Register.vue';

export default defineNuxtComponent({
  name: 'Theme7RegisterEntry',

  mixins: [ComponentMixin],

  extends: RegisterEntry,

  components: {
    RegisterEntry,
    Register,
  },
});
</script>
